import axios from "axios";
import router from '../../router';
import slug from 'slug';
import qs from 'qs';

// initial state
const state = () => ({

  })

// getters
const getters = {

}

// actions
const actions = {
    
    getCashRegister: {
        //root: true,
        handler (context, query){
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: context.rootGetters.getApiUrl + '/financiar/getCashRegister',
                    params: query,
                    paramsSerializer: function(params) {
                        return qs.stringify(params, {arrayFormat: 'repeat'})
                    },
                    headers: { 
                        Authorization: 'Bearer ' + context.rootGetters.getToken,
                        Accept: '*/*'
                    }
                })
                .then(response => {

                    let company = slug(context.rootGetters.getManagerCompanies.find(el => el.id == query.companyId ).companyName);

                    var fileURL = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf"}));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'RegistruDeCasa_'+company+'_'+query.dateFrom+'-'+query.dateTo+'.pdf');
                    document.body.appendChild(fileLink);

                    fileLink.click();

                    resolve(response);
                })
                .catch(error => {

                    if(error.response.status === 401){
                        //context.dispatch('destroyToken');
                        context.dispatch('destroyToken', null, { root: true })
                            .then(() => {
                                router.push({ name: 'login' });
                            })
                    }
                    reject(error);
                })
            });
        }
    },
}

// mutations
const mutations = {

}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}